import darkStyles from "@tmca/lexus-dls/css/dark.module.css";
import lightStyles from "@tmca/lexus-dls/css/light.module.css";

import { ThemeDefinition } from "./themingTypes";

// We use this special self-calling function syntax to remove *Styles calls from module level and allow
// tree shaking on consumer, for some bundlers we add # __PURE__ instruction to make it explicit that
// this can be dropped if not used

/**
 * When you use this variable your bundler will trace it to @tmca/lexus-dls/css/dark.module.css file.
 * Since it is CSS Module it is your bundler responsibility to import and bundle it correctly with your CSS.
 * The string value inside it will depend on your bundler, it is not hardcoded in Lexus Kit, so you have full
 * control over it.
 */
export const darkTheme: ThemeDefinition = /*#__PURE__*/ (() => ({
  rootClassName: darkStyles.ldDarkTheme,
  staticClassName: darkStyles.ldTheme,
  variantClassNames: {
    default: darkStyles.ldVariantDefault,
    alt: darkStyles.ldVariantAlt,
  },
}))();

/**
 * When you use this variable your bundler will trace it to @tmca/lexus-dls/css/light.module.css file.
 * Since it is CSS Module it is your bundler responsibility to import and bundle it correctly with your CSS.
 * The string value inside it will depend on your bundler, it is not hardcoded in Lexus Kit, so you have full
 * control over it.
 */
export const lightTheme: ThemeDefinition = /*#__PURE__*/ (() => ({
  rootClassName: lightStyles.ldLightTheme,
  staticClassName: lightStyles.ldTheme,
  variantClassNames: {
    default: lightStyles.ldVariantDefault,
    alt: lightStyles.ldVariantAlt,
  },
}))();
